<template>
  <v-data-table :headers="headers"
                :loading="loading"
                :items="data"
                no-data-text="No cases vs materials data"
                hide-actions>
    <template slot="items" slot-scope="props">
      <tr>
        <td>{{ props.item.date }}</td>
        <td>{{ props.item.casesCreatedCount }}</td>
        <td>{{ props.item.incomingRawMaterialsCount }}</td>
        <td>{{ props.item.slidesCreatedFromIncomingHistoblocksCount }}</td>
        <td>{{ props.item.incomingHistoblocksRegisteredCount }}</td>
        <td>{{ props.item.incomingSlidesScannedCount }}</td>
        <td>{{ props.item.newHistoblocksCreatedCount }}</td>
        <td>{{ props.item.ihcSlidesCount }}</td>
        <td>{{ props.item.hcSlidesCount }}</td>
        <td>{{ props.item.heSlidesCount }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'CasesVsMaterials',
  props: {
    data: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Date',
          align: 'left',
          sortable: false
        },
        {
          text: 'New cases created',
          align: 'left',
          sortable: false
        },
        {
          text: 'Incoming Raw Material',
          align: 'left',
          class: 'blue-th',
          sortable: false
        },
        {
          text: 'Slides Created From Incoming Histoblocks',
          align: 'left',
          class: 'blue-th',
          sortable: false
        },
        {
          text: 'Incoming Histoblocks Registered',
          align: 'left',
          class: 'blue-th',
          sortable: false
        },
        {
          text: 'Incoming Slides Scanned',
          align: 'left',
          class: 'blue-th',
          sortable: false
        },
        {
          text: 'New Histoblocks Created',
          align: 'left',
          class: 'green-th',
          sortable: false
        },
        {
          text: 'New IHC Slides Created',
          align: 'left',
          class: 'green-th',
          sortable: false
        },
        {
          text: 'New HC Slides Created',
          align: 'left',
          class: 'green-th',
          sortable: false
        },
        {
          text: 'New H&E Slides Created',
          align: 'left',
          sortable: false,
          class: 'green-th'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .blue-th {
    color: #0D47A1 !important;
  }

  .green-th {
    color: #1B5E20 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/CasesVsMaterials.vue